import { filter } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms'
import { Address } from '../../../core/models/address';

@Component({
  selector: 'app-addresses',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressesComponent implements OnChanges {
  selected: Address
  addressesSelect: FormControl = new FormControl()
  selectActive = false
  myTranslationCode: string

  @Input() addresses: Address[]
  @Input() current: string
  @Output() addressChanged = new EventEmitter<Address>()

  constructor() {
    this.addressesSelect.valueChanges.pipe(
      filter((address => (address && address.code) !== this.current).bind(this)))
      .subscribe(this.selectedChanged.bind(this))

      this.myTranslationCode = "checkout.delivery-address";
  }

  ngOnChanges(changes: SimpleChanges) {
      let addresses = (changes.addresses && changes.addresses.currentValue) || this.addresses
      // let current = (changes.current && changes.current.currentValue) || this.current

      // Only prefill the address if there's only one address available.
      if (addresses && addresses.length === 1) {
        this.addressesSelect.setValue(addresses[0])
        this.selected = addresses[0]
      }

      // let defAddress = addresses && Array.isArray(addresses)
      //   ? addresses.find(a => (a && a.code) === current)
      //     || addresses.find(a => a.isPrimary)
      //     || addresses[0]
      //   : null

      // this.addressesSelect.setValue(defAddress)
      // this.selected = defAddress
  }

  get hasMultiple() {
    return this.addresses.length > 1
  }

  toggleSelect() {
    this.selectActive = !this.selectActive
  }

  selectedChanged(address: Address) {
    this.selected = address
    this.addressChanged.emit(address)
  }

  onAddressClick(address: Address) {
    this.selected = address
    this.addressChanged.emit(address)
    this.selectActive = false
  }


}
